import { render, staticRenderFns } from "./QuestAddress.vue?vue&type=template&id=68637d8e&scoped=true&"
import script from "./QuestAddress.ts?vue&type=script&lang=ts&"
export * from "./QuestAddress.ts?vue&type=script&lang=ts&"
import style0 from "./QuestAddress.scss?vue&type=style&index=0&id=68637d8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68637d8e",
  null
  
)

export default component.exports